import request from '@/plugins/axios'

//申请列表
export const apiScoreList = (params: any) => request.get('/score.admin_score_apply/lists', { params })
//发放积分
export const apiScoreAudit = (data: any) => request.post('/score.admin_score_apply/audit', data)
//驳回申请
export const apiScoreTurn = (data: any) => request.post('/score.admin_score_apply/recycleScore', data)
//积分回收
export const apiScoreGrant = (data: any) => request.post('/score.admin_score/grant', data)
//积分发放
export const apiScoreRecycle = (data: any) => request.post('/score.admin_score_apply/recycleScore', data)
//企业列表
export const apiScoreShops = (params: any) => request.get('/score.admin_score/lists', { params })
//明细
export const apiScoreDetail = (params: any) => request.get('/score.admin_score_log/lists', { params })
